import { fetchOrThrowBlob } from '@upright/ui/api/common/fetchers/fetch-or-throw';
import { useMutation } from '@tanstack/react-query';
import { GetRenderRequest } from '../../../../common/renderer/api-types';

export function useScreenshotMutation() {
  return useMutation({
    mutationKey: ['takeScreenshot'],

    mutationFn: async (input: { data: GetRenderRequest }) => {
      return await fetchOrThrowBlob(`/render`, 'POST', input.data);
    },
  });
}
